import React from 'react';
import dynamic from 'next/dynamic';

const FORMULAR_MAPPING: {
  [index: string]: React.ComponentType<any>;
} = {
  order: dynamic(() => import('../components/Forms/EbikeAtlasOrderForm')),
  reorder: dynamic(() => import('../components/Forms/EbikeAtlasOrderForm')),
  contact: dynamic(() => import('../components/Forms/ContactForm')),
};

export default FORMULAR_MAPPING;
